{
  "schemaVersion": 1,
  "key": "beach",
  "name": "Beach",
  "version": "1.0.0",
  "author": "classy core",
  "backgrounds": {
    "home": "backgrounds/home2.png"
  },
  "mascot": {
    "home": "mascot/crab2.png"
  },
  "tokens": {
    "accent": "#85BEA1"
  }
}
